import { useState, useCallback } from 'react';
import { apiClient } from '../api/client';
import { Holder } from '../utils/holders';

export interface HolderPayload {
  name: string;
  oab_number: string | null;
  oab_uf: string | null;
}

export interface BulkHolderResult {
  updated: string[];
  skipped: string[];
}

export function useHolders() {
  const [holders, setHolders] = useState<Holder[]>([]);

  const fetchHolders = useCallback(async () => {
    try {
      setHolders(await apiClient.get<Holder[]>('/holders'));
    } catch (err) {
      // Sem titulares a página continua funcionando: tudo aparece em "Sem titular".
      console.error('Falha ao carregar titulares', err);
    }
  }, []);

  const createHolder = async (payload: HolderPayload) => {
    await apiClient.post('/holders', payload);
    await fetchHolders();
  };

  const updateHolder = async (id: string, payload: HolderPayload) => {
    await apiClient.patch(`/holders/${id}`, payload);
    await fetchHolders();
  };

  const archiveHolder = async (id: string) => {
    await apiClient.delete(`/holders/${id}`);
    await fetchHolders();
  };

  const moveCredentials = async (credentialIds: string[], holderId: string | null): Promise<BulkHolderResult> => {
    const result = await apiClient.patch<BulkHolderResult>('/credentials/bulk-holder', {
      credential_ids: credentialIds,
      holder_id: holderId,
    });
    await fetchHolders();
    return result;
  };

  return { holders, fetchHolders, createHolder, updateHolder, archiveHolder, moveCredentials };
}
